import React from "react";
import "./modal.css";
import { IoMdClose } from "react-icons/io";

const Modal = ({ message, closeModal, buttonAction, buttonText }) => {
  const handleContentClick = (event) => {
    event.stopPropagation(); 
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={handleContentClick}>
        <p>{message}</p>
        <div className="button-container">
          <button onClick={buttonAction} className={"modal-button"}>{buttonText}</button>
        </div>
        <button onClick={closeModal} className={"close-modal"}><IoMdClose size={36} /></button>
      </div>
    </div>
  );
};

export default Modal;